import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { useTranslation } from "react-i18next";
import { FieldTimeOutlined } from "us.icons";
import "./Style.scss";
import Common from "us.common";
import { DelayPayment } from "./Components";
import { RootState } from "us.helper/types";
import { isFutureOrTodayManualDueDate } from "./Functions";

const { $Tooltip, $Button, $Drawer, $Row, $Col } = Common.Components;

/**
 * @description - Case delay home component
 * @link Design Document -
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 23/09/2025
 */

const NewCaseDelay: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const { accountSummeryWidgetData, metaData } = props;
  const { paymentAgreementBasic, partPaymentBasic, case: caseData} = accountSummeryWidgetData?.data ?? {}
  const { manualDueDate } = caseData ?? {};
  const { isObjected } = metaData.data ?? {};

  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  return (
    <>
      <$Row gutter={16} className="case-action-list">
        <$Col xxl={{ span: 12 }} xl={{ span: 10 }}>
          <div className="case-action-list-wrap">
            <div className="case-action-list-header">
              <span>{t("US.COLLECTION.CASE:CASE_DELAY.DELAY_PAYMENT")}</span>
            </div>
            <div className="d-flex flex-wrap case-action-list-body case-action-delay">
              <$Tooltip
                placement="top"
                title={t("US.COLLECTION.CASE:CASE_DELAY.DELAY_PAYMENT")}
              >
                <$Button
                  type="default"
                  onClick={() => setIsOpenDrawer(true)}
                  disabled={isFutureOrTodayManualDueDate(manualDueDate) || isObjected || paymentAgreementBasic || partPaymentBasic}
                >
                  <FieldTimeOutlined style={{ fontSize: "120%" }} />
                </$Button>
              </$Tooltip>
            </div>
          </div>
        </$Col>
      </$Row>

      <$Drawer
        title={t("US.COLLECTION.CASE:CASE_DELAY.DELAY_PAYMENT")}
        width={600}
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(false)}
        destroyOnClose
      >
        <DelayPayment onClose={() => setIsOpenDrawer(false)} />
      </$Drawer>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { dashboard, domainView } = state;
  const { accountSummeryWidgetData } = dashboard;
  const { metaData } = domainView;
  return {
    accountSummeryWidgetData,
    metaData
  };
};

const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(NewCaseDelay);
